import React from 'react'
import { Typography } from '@mui/material'
import ContentMediaField from './content-media-field'

interface ContentMediaProps {
  disabled?: boolean
  onChange: (event: { target: { name: string; value: string | null } }) => void
  values: {
    previewMediaId?: string | null
    featureMediaId?: string | null
  }
  contentLanguage?: string | null
  primaryLanguage?: string | null
}

/**
 * ContentMedia Component
 * Renders media selection and preview UI for content detail forms.
 * Handles autocomplete, media validation, and metadata display for preview and feature media.
 */
function ContentMedia (props: ContentMediaProps) {
  const {
    disabled = false,
    onChange,
    values,
    contentLanguage = null,
    primaryLanguage = null,
  } = props

  const previewMediaId = values.previewMediaId || null
  const featureMediaId = values.featureMediaId || null

  const clearMediaField = (name: string) => {
    onChange({ target: { name, value: null } })
  }

  return (
    <>
      <Typography
        variant="h6"
        sx={{
          mt: 3,
          mb: 2,
          color: '#333',
          fontWeight: 600,
          borderBottom: '2px solid #e0e0e0',
          pb: 1,
        }}
      >
        Preview Media
      </Typography>
      <ContentMediaField
        name="previewMediaId"
        mediaId={previewMediaId}
        onChange={onChange}
        disabled={disabled}
        clearMediaField={clearMediaField}
        contentLanguage={contentLanguage}
        primaryLanguage={primaryLanguage}
      />
      <Typography
        variant="h6"
        sx={{
          mt: 4,
          mb: 2,
          color: '#333',
          fontWeight: 600,
          borderBottom: '2px solid #e0e0e0',
          pb: 1,
        }}
      >
        Feature Media
      </Typography>
      <ContentMediaField
        name="featureMediaId"
        mediaId={featureMediaId}
        onChange={onChange}
        disabled={disabled}
        clearMediaField={clearMediaField}
        contentLanguage={contentLanguage}
        primaryLanguage={primaryLanguage}
      />
    </>
  )
}

export default ContentMedia
